/**
 * BUILD YOUR BAG — Homepage single-card mini-PDP
 * Step 1 picks a bag colour (one block per bag); Step 2 shows that bag's prints;
 * Step 3 strap; Step 4 embroidery. Click-to-magnify lightbox for the active print.
 *
 * Cart payload mirrors the PDP picker (snippets/senshi-bag-fields + senshi-cart.js):
 *   - bag item with `_strap_variant_id` property -> Shopify Flow deducts strap inventory
 *   - optional embroidery line item with text property
 *
 * Adds via the theme's shared cart store and opens the cart drawer after
 * add (falls back to /cart when the drawer isn't in the DOM, i.e. cart
 * type is set to "page") -- same pattern as senshi-cart.js.
 */
import Cart from 'cart-store';

(function () {
  'use strict';

  var ENGLISH_ONLY = /^[A-Za-z0-9 \-'.]*$/;
  function stripNonEnglish(str) { return str.replace(/[^A-Za-z0-9 \-'.]/g, ''); }

  function init() {
    var cards = document.querySelectorAll('[data-byb-card]');
    cards.forEach(initCard);
  }

  function initCard(card) {
    var configEl = card.querySelector('script.byb-config');
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

    var embroideryPriceCents = parseInt(config.embroideryPriceCents, 10) || 0;
    var embroideryVariantId = config.embroideryVariantId || null;

    // Capture currency suffix from existing displayed price (e.g. " AUD")
    var priceEl = card.querySelector('[data-byb-price]');
    var currencySuffix = '';
    if (priceEl) {
      var m = priceEl.textContent.match(/^\s*\$?[\d,]+(?:\.\d+)?(.*)$/);
      if (m && m[1]) currencySuffix = m[1];
    }
    function formatMoney(cents) {
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars + currencySuffix;
    }
    function updatePrice() {
      if (!priceEl) return;
      var addOn = (embToggle && embToggle.checked && embroideryVariantId) ? embroideryPriceCents : 0;
      priceEl.textContent = formatMoney(activeBagPriceCents + addOn);
    }

    // ── Bag swatches (Step 1) ──
    var bagSwatches = card.querySelectorAll('[data-byb-bag-swatches] .byb-swatch');
    var bagDisplay = card.querySelector('[data-byb-bag-display]');
    var mainImage = card.querySelector('[data-byb-main-image]');
    var printGroups = card.querySelectorAll('.byb-print-group');
    var printDisplay = card.querySelector('[data-byb-print-display]');

    var activeBagId = null;
    var activeBagPriceCents = 0;

    // Seed active bag from the swatch already marked active in markup
    var defaultBagSwatch = card.querySelector('[data-byb-bag-swatches] .byb-swatch--active') || bagSwatches[0];
    if (defaultBagSwatch) {
      activeBagId = defaultBagSwatch.dataset.bagId;
      activeBagPriceCents = parseInt(defaultBagSwatch.dataset.basePrice, 10) || 0;
    }

    function setActiveBag(swatch) {
      var newId = swatch.dataset.bagId;
      if (!newId) return;

      bagSwatches.forEach(function (s) { s.classList.remove('byb-swatch--active'); });
      swatch.classList.add('byb-swatch--active');

      var radio = swatch.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      activeBagId = newId;
      activeBagPriceCents = parseInt(swatch.dataset.basePrice, 10) || 0;

      if (bagDisplay) bagDisplay.textContent = swatch.dataset.colour || '';

      if (mainImage && swatch.dataset.mainImage) {
        mainImage.src = swatch.dataset.mainImage;
        mainImage.alt = swatch.dataset.colour || '';
      }

      // Show this bag's print group, hide others
      printGroups.forEach(function (group) {
        if (group.dataset.bagId === newId) {
          group.hidden = false;
        } else {
          group.hidden = true;
        }
      });

      // Refresh the print-display label to whichever print is active in the now-visible group
      syncPrintDisplay();
      updatePrice();
    }

    bagSwatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        setActiveBag(sw);
      });
    });

    // ── Print swatches (Step 2) — wired per group ──
    function syncPrintDisplay() {
      if (!printDisplay) return;
      var activeGroup = card.querySelector('.byb-print-group[data-bag-id="' + activeBagId + '"]');
      if (!activeGroup) { printDisplay.textContent = ''; return; }
      var activePrint = activeGroup.querySelector('.byb-swatch--active');
      printDisplay.textContent = activePrint ? (activePrint.dataset.value || '') : '';
    }

    printGroups.forEach(function (group) {
      var swatches = group.querySelectorAll('.byb-swatch');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          if (sw.dataset.available === 'false') { e.preventDefault(); return; }
          swatches.forEach(function (s) { s.classList.remove('byb-swatch--active'); });
          sw.classList.add('byb-swatch--active');
          var radio = sw.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
          if (group.dataset.bagId === activeBagId && printDisplay) {
            printDisplay.textContent = sw.dataset.value || '';
          }
        });
      });
    });

    syncPrintDisplay();

    // ── Print magnify lightbox ──
    var magnifyBtn = card.querySelector('[data-byb-magnify]');
    // Modal markup lives at the wrapper level (sibling of the card)
    var modal = card.closest('.byb-wrapper') ? card.closest('.byb-wrapper').querySelector('[data-byb-modal]') : null;
    var modalImage = modal ? modal.querySelector('[data-byb-modal-image]') : null;
    var modalCaption = modal ? modal.querySelector('[data-byb-modal-caption]') : null;
    var modalCloseEls = modal ? modal.querySelectorAll('[data-byb-modal-close]') : [];

    function openModal() {
      if (!modal) return;
      var activeGroup = card.querySelector('.byb-print-group[data-bag-id="' + activeBagId + '"]');
      if (!activeGroup) return;
      var activePrint = activeGroup.querySelector('.byb-swatch--active');
      if (!activePrint) return;

      var src = activePrint.dataset.largeImage || '';
      var caption = activePrint.dataset.value || '';
      if (!src) return;

      if (modalImage) { modalImage.src = src; modalImage.alt = caption; }
      if (modalCaption) modalCaption.textContent = caption;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    if (magnifyBtn) {
      magnifyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    }

    modalCloseEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    // ── Strap swatches (Step 3) ──
    var strapSwatches = card.querySelectorAll('[data-byb-strap-swatches] .byb-swatch');
    var strapDisplay = card.querySelector('[data-byb-strap-display]');
    strapSwatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        if (sw.dataset.available === 'false') { e.preventDefault(); return; }
        strapSwatches.forEach(function (s) { s.classList.remove('byb-swatch--active'); });
        sw.classList.add('byb-swatch--active');
        var radio = sw.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        if (strapDisplay) strapDisplay.textContent = sw.dataset.colour || '';
      });
    });

    // ── Embroidery toggle + text (Step 4) ──
    var embToggle = card.querySelector('[data-byb-emb-toggle]');
    var embFields = card.querySelector('[data-byb-emb-fields]');
    var embText = card.querySelector('[data-byb-emb-text]');
    var charCount = card.querySelector('[data-byb-char-count]');
    var embError = card.querySelector('[data-byb-emb-error]');

    function showEmbError(msg) { if (embError) { embError.textContent = msg; embError.style.display = 'block'; } }
    function clearEmbError() { if (embError) embError.style.display = 'none'; }

    if (embToggle && embFields) {
      embToggle.addEventListener('change', function () {
        embFields.style.display = embToggle.checked ? 'block' : 'none';
        if (!embToggle.checked && embText) {
          embText.value = '';
          if (charCount) charCount.textContent = '0';
          clearEmbError();
        }
        if (embToggle.checked && embText) embText.focus();
        updatePrice();
      });
    }

    if (embText) {
      embText.addEventListener('input', function () {
        var cursor = embText.selectionStart;
        var original = embText.value;
        var cleaned = stripNonEnglish(original);
        if (cleaned !== original) {
          embText.value = cleaned;
          var removed = original.length - cleaned.length;
          embText.setSelectionRange(cursor - removed, cursor - removed);
          showEmbError('English characters only (A-Z, 0-9, spaces and basic punctuation).');
        } else {
          clearEmbError();
        }
        if (charCount) charCount.textContent = embText.value.length;
      });
      embText.addEventListener('paste', function (e) {
        e.preventDefault();
        var pasted = (e.clipboardData || window.clipboardData).getData('text');
        var cleaned = stripNonEnglish(pasted).substring(0, 10);
        var start = embText.selectionStart;
        var end = embText.selectionEnd;
        var current = embText.value;
        var newVal = (current.substring(0, start) + cleaned + current.substring(end)).substring(0, 10);
        embText.value = newVal;
        if (charCount) charCount.textContent = newVal.length;
        if (pasted !== cleaned) showEmbError('Non-English characters were removed from your paste.');
        else clearEmbError();
      });
    }

    // ── ATC ──
    var atcBtn = card.querySelector('[data-byb-atc]');
    var errorEl = card.querySelector('[data-byb-error]');

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
      setTimeout(function () { errorEl.style.display = 'none'; }, 5000);
    }
    function setLoading(loading) {
      if (!atcBtn) return;
      if (loading) { atcBtn.classList.add('is-loading'); atcBtn.setAttribute('disabled', 'disabled'); }
      else { atcBtn.classList.remove('is-loading'); atcBtn.removeAttribute('disabled'); }
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        handleAddToCart();
      });
    }

    async function handleAddToCart() {
      var activeGroup = card.querySelector('.byb-print-group[data-bag-id="' + activeBagId + '"]');
      var printRadio = activeGroup ? activeGroup.querySelector('input[type="radio"]:checked') : null;
      var bagVariantId = printRadio ? parseInt(printRadio.dataset.variantId, 10) : null;
      if (!bagVariantId) { showError('Please select an Inner Print.'); return; }

      var strapRadio = card.querySelector('input[name="byb-strap"]:checked');
      var strapColour = strapRadio ? strapRadio.value : '';
      var strapVariantId = strapRadio ? strapRadio.dataset.variantId : null;

      var embEnabled = embToggle ? embToggle.checked : false;
      var embTextValue = embText ? embText.value.trim() : '';
      if (embEnabled && !embTextValue) { showError('Please enter your embroidery text.'); if (embText) embText.focus(); return; }
      if (embEnabled && embTextValue.length > 10) { showError('Embroidery text must be 10 characters or less.'); if (embText) embText.focus(); return; }
      if (embEnabled && !ENGLISH_ONLY.test(embTextValue)) { showError('Embroidery text must use English characters only.'); if (embText) embText.focus(); return; }

      var items = [];
      var bagItem = { id: bagVariantId, quantity: 1, properties: {} };
      if (strapColour) bagItem.properties['Strap Colour'] = strapColour;
      if (strapVariantId) bagItem.properties['_strap_variant_id'] = strapVariantId;
      if (embEnabled && embTextValue) bagItem.properties['Strap Embroidery'] = embTextValue;
      items.push(bagItem);

      if (embEnabled && embTextValue && embroideryVariantId) {
        items.push({
          id: embroideryVariantId,
          quantity: 1,
          properties: { 'Embroidery Text': embTextValue }
        });
      }

      setLoading(true);
      try {
        await Cart.add(items);
        openCartDrawer();
      } catch (err) {
        showError(err.message || 'Error adding to cart. Please try again.');
      } finally {
        setLoading(false);
      }
    }

    // ── Open the theme's cart drawer (same pattern as product-form.js) ──
    function openCartDrawer() {
      var cartModal = document.querySelector('.modal--cart, .popup--cart-notification');
      if (!cartModal) {
        window.location.href = '/cart';
        return;
      }
      if (!cartModal.shown) {
        cartModal.open();
      } else if (cartModal.interval) {
        cartModal.interval.reset();
        cartModal.interval.start();
      }
    }

    updatePrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
